var R={PRIMARY:"PRIMARY",PRIMARY_DESTRUCTIVE:"PRIMARY_DESTRUCTIVE",SECONDARY:"SECONDARY",SECONDARY_DESTRUCTIVE:"SECONDARY_DESTRUCTIVE"};export{R as VARIANTS};
//# sourceMappingURL=variantsConst.js.map
